module.exports = __webpack_public_path__ + "static/main-variant-desktop-8a1148f1dcae08d237ea58c8108e8cc3.webp";